import type { Result } from "@pdfking/tfunc"

export const AutoThrow = <T>(result: Result<T>): T => {
  if (result.error) throw result.error
  return result.value
}
